
require("expose-loader?exposes=$!jquery");

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ngMaterial from 'angular-material';
import angularTranslate from 'angular-translate';
import googleAnalytics from 'angulartics-google-analytics';

import gazelle from 'gazelle';
import rhino from 'rhino';
import * as ComposerController from './composer.controller';
import cacheComposerImages from './cache-images.run.js';
import * as ecommerceFactory from "./components/ecommerce/ecommerceFactory";

// Pull in all component modules here.
// In the future, look to introduce webpack split points for performance
// in the router configuration.
// See https://github.com/ay13/webpack-angular-oclazyload/blob/master/app/config.js#L43
let composerModuleNames = requireAllModules();

export default angular.module('composer',[
        'angulartics',
        ngMaterial,
        uiRouter,
        rhino,
        gazelle,
        googleAnalytics,
        angularTranslate
    ].concat(composerModuleNames)
)
    .config(composerConfig)
    .config(configLocCatalogs)
    .run(composerRun)
    .run(cacheComposerImages)
    .factory(ecommerceFactory.name, ecommerceFactory.default)
    .controller(ComposerController.name, ComposerController.default)
    .name;


function requireAuthentication(rnAuthService) {
    'ngInject';
    return rnAuthService.authenticate();
}

function composerConfig($stateProvider, $urlRouterProvider) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    // Redirect for any unmatched url
    $urlRouterProvider.otherwise("/templates");

    //
    // Now set up the states
    $stateProvider
        .state('templates', {
            url: '/templates',
            template: require('./components/templates/templateslist.html'),
            controller: 'TemplateListController',
            controllerAs: 'vm',
            breadcrumbName:'imposer.composer-main.Template_Imposition_Templates',
            resolve: { auth: requireAuthentication}
        })
        .state('pdflist',{
            url:'/pdflist',
            template: require('./components/templates/pdf_list_view/pdfList.html'),
            controller:'pdfListController',
            controllerAs: 'vm',
            resolve: { auth: requireAuthentication}
        })
        .state('quota', {
          url: '/quota',
          template: require('./components/ecommerce/quota-details/quota.html'),
          controller:'quotaController',
          controllerAs: 'vm',
          resolve: { auth: requireAuthentication}
        })
        .state('assets-management', {
          url: '/assets-management',
          template: require('./components/assets-management/assets-management.html'),
          controller:'assetsManagementsController',
          controllerAs: 'vm',
          resolve: { auth: requireAuthentication}
        })
        .state('sdk-management', {
          url: '/sdk-management',
          template: require('@printos/imposer-ui/src/components/common/sdk-management/sdk-management.html'),
          controller:'sdkManagementsController',
          controllerAs: 'vm',
          params:{app: 'composer'},
          resolve: { auth: requireAuthentication}
        })
        .state('administration', {
          url: '/administration',
          template: require('./components/admin/administration.html'),
          controller:'adminController',
          controllerAs: 'vm',
          resolve: { auth: requireAuthentication}
        })
        .state('presets', {
          url: '/presets',
          template: require('./components/presets/presets-list.html'),
          controller:'presetsListController',
          controllerAs: 'vm',
          resolve: { auth: requireAuthentication}
        })
        .state('presets.presetdetails', {
          url: '/{presetId}',
          params: {
            preset: null,
            mode: null
          },
          template: require('./components/presets/preset-details/preset-details.html'),
          controller:'presetDetailsController',
          controllerAs: 'vm',
          resolve: { auth: requireAuthentication}
        })
        .state('presets.presetdetails.imposition', {
          url: '/imposition/{templateId}',
          template: require('./components/templates/impositionTemplateDetails.html'),
          breadcrumbName:'imposer.composer-main.Template_Imposition_Imposition_Template',
          params:{composerTemplateId:null,templateId:null,trimBox:null, mediaBox:null, hpdFileName:null},
          resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetails', {
            url: '/{composerTemplateId}',
            params: {
              composerTemplate: null
            },
            template: require('./components/templates/template-details/detailedTemplateLayout.html'),
            controller:'templateDetailsDirective',
            controllerAs: 'vm',
            breadcrumbName:'imposer.composer-main.Template_Imposition_Template',
            resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetails.imposedpreview', {
            url: '/impositionpreview',
            template: require('./components/templates/zoom_in/imposition/impositionPreviewZoominPage.html'),
            breadcrumbName:'imposer.composer-main.Composer_Preview_With_Imposition',
            params:{
                composerTemplateId:null,
                isDuplex:null,
                data:null,
                templateName: null,
                dataFileName: null,
                assetsLibrariesStorageIds: null
            },
            resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetails.pagepreview', {
            url: '/pagerecordpreview',
            template: require('./components/templates/zoom_in/page-record/pageRecordPreviewZoominpage.html'),
            breadcrumbName:'imposer.composer-main.Composer_Page_Preview',
            params:{
                composerTemplateId:null,
                data:null,
                templateName: null,
                dataFileName: null,
                totalPages:null,
                recordNumber:null,
                pageNumber:null,
                headers:null,
                assetsLibrariesStorageIds: null
            },
            resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetails.imposition', {
            url: '/imposition/{templateId}',
            template: require('./components/templates/impositionTemplateDetails.html'),
            breadcrumbName:'imposer.composer-main.Template_Imposition_Imposition_Template',
            params:{composerTemplateId:null,templateId:null,trimBox:null, mediaBox:null, hpdFileName:null},
            resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetails.imposition.zoomin', {
            url: '/zoomin/{templateId}/{templateName}/{sheetNumber}/{previewType}/{side}/{totalSheets}/{isDuplex}/{breadcrumbsName}/{schemaPdfUrl}/{inputPdfUrl}',
            template: require('@printos/imposer-ui/src/components/templates/imposer-zoom-in-page/ImposerZoomIn.html'),
            controller: 'ImposerZoomInController',
            breadcrumbName:'imposer.composer-main.Template_Preview',
            controllerAs: 'vm',
            params:{
                composerTemplateId:null,
                templateId:null,
                trimBox:null,
                mediaBox:null,
                hpdFileName:null,
                isDuplex: null,
                sheetNumber: null,
                previewType:null,
                schemaPdfUrl: null,
                schemaPdfStorageId: null,
                disabledPreviewSwitch: null,
                inputPdfUrl:null,
                side: null,
                templateName: null,
                breadcrumbsName:null,
                totalSheets:null},
            resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetails.fulldataview', {
            url: '/fulldataview/{dataFileName}',
            template: require('./components/templates/fullDataFileView.html'),
            params:{data:null,headers:null,isDataFileLimitExceeded:false,repetitionColumn:null},
            resolve: { auth: requireAuthentication}
        })
        // with data from cloud
        .state('templates.templatedetailswithdata', {
            url: '/{composerTemplateId}/data/{dataFileName}/{dataFileStorageId}',
            template: require('./components/templates/template-details/detailedTemplateLayout.html'),
            controller:'templateDetailsDirective',
            controllerAs: 'vm',
            breadcrumbName:'imposer.composer-main.Template_Imposition_Template',
            resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetailswithdata.imposedpreview', {
            url: '/impositionpreview',
            template: require('./components/templates/zoom_in/imposition/impositionPreviewZoominPage.html'),
            breadcrumbName:'imposer.composer-main.Composer_Preview_With_Imposition',
            params:{
                composerTemplateId:null,
                isDuplex:null,
                data:null,
                templateName: null,
                dataFileName: null,
                dataFileStorageId:null,
                assetsLibrariesStorageIds: null
            },
            resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetailswithdata.pagepreview', {
            url: '/pagerecordpreview',
            template: require('./components/templates/zoom_in/page-record/pageRecordPreviewZoominpage.html'),
            breadcrumbName:'imposer.composer-main.Composer_Page_Preview',
            params:{
                composerTemplateId:null,
                data:null,
                templateName: null,
                dataFileName: null,
                totalPages:null,
                recordNumber:null,
                pageNumber:null,
                headers:null,
                dataFileStorageId:null,
                assetsLibrariesStorageIds: null
            },
            resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetailswithdata.imposition', {
            url: '/imposition/{templateId}',
            template: require('./components/templates/impositionTemplateDetails.html'),
            breadcrumbName:'imposer.composer-main.Template_Imposition_Imposition_Template',
            params:{composerTemplateId:null,templateId:null,trimBox:null, mediaBox:null, hpdFileName:null},
            resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetailswithdata.imposition.zoomin', {
            url: '/zoomin/{templateId}/{templateName}/{sheetNumber}/{previewType}/{side}/{totalSheets}/{isDuplex}/{breadcrumbsName}/{schemaPdfUrl}/{inputPdfUrl}',
            template: require('@printos/imposer-ui/src/components/templates/imposer-zoom-in-page/ImposerZoomIn.html'),
            controller: 'ImposerZoomInController',
            breadcrumbName:'imposer.composer-main.Template_Preview',
            controllerAs: 'vm',
            params:{
                composerTemplateId:null,
                templateId:null,
                trimBox:null,
                mediaBox:null,
                hpdFileName:null,
                isDuplex: null,
                sheetNumber: null,
                previewType:null,
                schemaPdfUrl: null,
                inputPdfUrl:null,
                side: null,
                templateName: null,
                breadcrumbsName:null,
                totalSheets:null,
                dataFileStorageId:null
            },
            resolve: { auth: requireAuthentication}
        })
        .state('templates.templatedetailswithdata.fulldataview', {
            url: '/fulldataview',
            template: require('./components/templates/fullDataFileView.html'),
            params:{data:null,headers:null,isDataFileLimitExceeded:false,repetitionColumn:null},
            resolve: { auth: requireAuthentication}
        });
}

function composerRun() {
    //noinspection BadExpressionStatementJS
    'ngInject';

    console.log('Composer App Running');
}

function configLocCatalogs($translateProvider) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    $translateProvider.useLoader('gzL10nLoader', {
        'catalogServices': {
            'imposer.composer-main': 'composer_service'
        }
    });
}

/**
 * Require all component modules and return the module names.
 * (This uses webpack's require.context() function to find and
 * then require all module files.)
 *
 * @returns {string[]} module names
 */
function requireAllModules() {
  let requiresModule = require.context('./components', true, /\.module\.js$/);
  let scriptFiles = requiresModule.keys();
  return scriptFiles.map(script => requiresModule(script).default);
}
window.breadcrumbs = [];
